import { ComponentProps } from 'react';
import { PayeeCheckLoadingCard } from '../components/payee-check-loading-card';
import { PaymentFlowStepWrapper } from '../components/payment-flow-step-wrapper';
import { CreateBeneficiaryForm } from '../create-beneficiary-flow/components/create-beneficiary-form';

type EditBeneficiaryFlowProps = Omit<ComponentProps<typeof CreateBeneficiaryForm>, 'wrapperConfig'> & {
  onGoBack: () => void;
};

export const EditBeneficiaryFlow = (props: EditBeneficiaryFlowProps) => {
  const { onGoBack, ...rest } = props;

  return (
    <PaymentFlowStepWrapper title="Edit recipient details" onGoBack={onGoBack}>
      {props.isLoading && <PayeeCheckLoadingCard />}

      <CreateBeneficiaryForm {...rest} />
    </PaymentFlowStepWrapper>
  );
};
